const actions = {
  methods: {
    toggle_ ({ catalog, id }) {
      this.$store.dispatch('saveMixed', { page: 2, type: 2, data: { catalog, id }, ignoreResponseBar: false })
    },
    delete_ ({ catalog, id, title }) {
      this.$store.dispatch('setOverlay', true)
      this.$root.$dialog.confirm({
        text: `${this.lang.services.dialog.deleteConfirm} ${title}?`,
        title: this.lang.confirm.title,
        waitForResult: true
      }).then(res => {
        this.$store.dispatch('setOverlay', false)
        if (res) this.$store.dispatch('saveMixed', { page: 2, type: 1, data: { catalog, id }, ignoreResponseBar: false })
      })
    }
  }
}
export default actions
